import React from 'react';
import '../styles/NewsSkeleton.css';

const NewsSkeleton = ({ count = 8, variant = 'default' }) => {
  return (
    <div className={`news-skeleton-grid news-skeleton-grid--${variant}`}>
      {Array.from({ length: count }).map((_, index) => (
        <div className="news-skeleton-card" key={index}>
          <div className="news-skeleton-image" />

          <div className="news-skeleton-content">
            <div className="news-skeleton-line news-skeleton-line--title" />
            <div className="news-skeleton-line news-skeleton-line--title-short" />
            <div className="news-skeleton-line news-skeleton-line--meta" />
            <div className="news-skeleton-tag" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default NewsSkeleton;
